module.exports = __webpack_public_path__ + "static/cover-e3dad6cf0de9ffd38ebaf6abc3a0ecc4.png";